module.exports = __webpack_public_path__ + "img/5.9bd58584.jpg";